import { Box } from '@chakra-ui/react'
import { GreyGrey30 } from '@sequencehq/design-tokens'

export const ProductGraphDivider = () => (
  <Box width="1px" height="100%" margin="0 24px" background={GreyGrey30}></Box>
)
